import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDateRangePicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { parse, format } from 'date-fns';
import { CustomDateAdapter, DATE_FORMAT } from '../custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from '../custom-date-formats';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

@Component({
  selector: 'adc-date-time-picker',
  templateUrl: './adc-date-time-picker.component.html',
  styleUrls: ['./adc-date-time-picker.component.scss'],
  providers: [
    DatePipe
  ],
  standalone: false
})
export class AdcDateTimePickerComponent {
  dateForm!: FormGroup;
  dateRangeForm!: FormGroup;
  startDate: any;
  endDate: any;
  @Input() type: any;
  @Input() dateFormat!: string;
  @Input() timePicker!: boolean;
  @Input() data: any;
  @Output() datevalue = new EventEmitter();
  @ViewChild('picker2') picker!: MatDateRangePicker<Date>;
  @ViewChild('timepicker') timepicker: any;
  userDateFormat: string = 'MM/DD/YYYY';
  @Input() timeFormat: '12' | '24' = '24';

  constructor(private datePipe: DatePipe) {
    this.dateForm = new FormGroup({
      date: new FormControl('',[Validators.required]),
      time: new FormControl('',[Validators.required])
    });
    this.dateRangeForm = new FormGroup({
      startDate: new FormControl('',[Validators.required]),
      endDate: new FormControl('', [Validators.required, this.validateDate()])
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dateFormat']) {
      this.updateDateFormats(this.dateFormat);
    }
  }

  updateDateFormats(format: string) {
    CUSTOM_DATE_FORMATS.display.dateInput = format; // Update display format
    CUSTOM_DATE_FORMATS.parse.dateInput = format; // Update parse format
  }

  ngOnInit(): void {
    // this.dateForm.valueChanges.subscribe(value => {
    //   // this.datevalue.emit(value);
    //   const { date, time } = this.convertToLocalTimezone(value.date, this.data.timeZone, value?.time);
    //   this.datevalue.emit({date: date, time: time});
    //   // console.log(value, 'Date');
    //   // console.log(date, time, 'Converted Date');
    // });
    // const date = this.data?.date;
    // const time = this.data?.time;
    // const timeZone = this.data?.timeZone;
    // this.patchDateTime(date, time, timeZone);
    this.dateForm.valueChanges.subscribe(value => {
      if (value?.date && value?.time) {
        try {
          const { date, time } = this.convertToLocalTimezone(value.date, this.data.timeZone, value?.time);
          this.datevalue.emit({ date, time });
        } catch (error) {
          console.error('Error converting to local timezone:', error);
        }
      }
    });
  
    const { date, time, timeZone } = this.data || {};
    if (date && time && timeZone) {
      this.patchDateTime(date, time, timeZone);
    } else {
      console.warn('Invalid initial data:', { date, time, timeZone });
    }
  }

  convertToLocalTimezone(apiDate: string,  apiTimezone: string, apiTime?: string): { date: Date, time: string } {
    // Combine the date and time into a single string for parsing
    const combinedDateTimeString = `${apiDate} ${apiTime}`;
  
    // Parse the combined date and time based on the input format (adjust based on API format)
    const parsedDate = parse(combinedDateTimeString, `${this.dateFormat} h:mm a`, new Date());
  
    // Convert from the source timezone to UTC
    const utcDate = fromZonedTime(parsedDate, apiTimezone);
  
    // Convert UTC to the local timezone
    const localDate = toZonedTime(utcDate, Intl.DateTimeFormat().resolvedOptions().timeZone);
  
    // Format the time string for ngx-timepicker
    const localTime = format(localDate, 'h:mm a');
  
    return { date: localDate, time: localTime };
  }

  getDate(event: any) {
    console.log(event);
    const formattedDate = format(event, this.dateFormat);
    console.log(formattedDate);
    this.datevalue.emit(formattedDate);
  }

  patchDateTime(apiDate: string, apiTime: string, apiTimezone: string) {
    const { date, time } = this.convertToLocalTimezone(apiDate, apiTimezone, apiTime);
  
    // Patch the local date to mat-datepicker
    // this.myForm.controls['datePickerControl'].setValue(date);
    this.dateForm.get('date')?.setValue(date);
    this.dateForm.get('time')?.setValue(time);
  
    // Patch the local time to ngx-timepicker
    // this.myForm.controls['timePickerControl'].setValue(time);
  }


  onFocus(field: string) {
    this.picker.open();
    if (field === 'end' && this.endDate) {
      // Open the end date picker and set the selected date
      const picker = document.querySelector(`#picker`) as any;
      picker.open();
      picker._selectDate(this.endDate);
    }
  }

  validateDate(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const dateValue = new Date(control.value);
      const selectedMonth = dateValue.getMonth();
      const selectedYear = dateValue.getFullYear();
      const selectedDay = dateValue.getDate();

      // Check if the selected date is valid for the selected month and year
      const isValidDate = selectedDay <= new Date(selectedYear, selectedMonth + 1, 0).getDate();

      // If the date is invalid, return an error
      return isValidDate ? null : { invalidDate: true };
    };
  }

  openTimePicker() {
    if (this.timepicker) {
      this.timepicker.open();
    }
  }

  date: any;
  time: any;

  onTimeChange(selectedtime: any) {
    const selectedDate = this.dateForm.get('date')?.value;
    const selectedTime = this.dateForm.get('time')?.value;

    if (selectedTime) {
      const formattedTime = this.formatTime(selectedTime); // Format the selected time
      this.dateForm.get('time')?.setValue(formattedTime);
    }
  }

  onStartDateChange(event: any) {
    this.startDate = event.value;
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.endDate = this.startDate;
    }
  }

  onEndDateChange(event: any) {
    this.endDate = event.value;
  }

  onEndDateFocus() {
    if (this.endDate) {
      // this.picker._calendar.activeDate = this.endDate;
      this.picker.open();
    }
  }

  onInputDateChange(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const inputDate = event?.target?.value;
    let inputValue = inputElement.value; // Keep numbers, letters, and spaces
    let month: string | number, day: number, year: number;

    if (!this.dateFormat) {
        console.error('dateFormat is not set');
        return;
    }

    switch (this.dateFormat) {
      case 'MM/dd/yyyy':
        [month, day, year] = inputValue.split('/').map(Number); // Split by '/'
        break;
      case 'dd/MM/yyyy':
          [day, month, year] = inputValue.split('/').map(Number); // Split by '/'
          break;
      case 'yyyy/MM/dd':
          [year, month, day] = inputValue.split('/').map(Number); // Split by '/'
          break;
      case 'MMMM d, y':
      case 'MMM d, y':
          const parts = inputValue.split(/\s+/);
          month = parts[0];
          day = parseInt(parts[1].replace(',', ''), 10);
          year = parseInt(parts[2], 10);
          break;
      default:
          month = parseInt(inputValue.slice(0, 2), 10);
          day = parseInt(inputValue.slice(3, 5), 10);
          year = parseInt(inputValue.slice(6, 10), 10);
          break;
    }

    const monthNames: any = {
        'MMMM d, y': [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ],
        'MMM d, y': [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ]
    };

    if (['MMMM d, y', 'MMM d, y'].includes(this.dateFormat)) {
        if (!monthNames[this.dateFormat].includes(month)) {
            this.dateForm.get('date')?.setErrors({ monthInvalid: true });
            return;
        }
        month = monthNames[this.dateFormat].indexOf(month) + 1; // Convert month to number
    }

    // Validate month, day, and leap year as before
    if (typeof month === 'number' &&(month < 1 || month > 12)) {
        this.dateForm.get('date')?.setErrors({ monthInvalid: true });
        return;
    }

    if (day < 1 || day > 31) {
        this.dateForm.get('date')?.setErrors({ dayInvalid: true });
        return;
    }

    if (month === 2 && day > (year % 4 === 0 ? 29 : 28)) {
        this.dateForm.get('date')?.setErrors({ leapYearInvalid: true });
        return;
    }

    if (year < 1900 || year > 2100) {
        this.dateForm.get('date')?.setErrors({ yearInvalid: true });
        return;
    }
    const date_ = inputDate ? inputDate : this.dateForm.get('date')?.value;
    // const { date, time } = this.convertToLocalTimezone(date_, this.data.timeZone, "");
    // this.datevalue.emit({date: date, time: time});
    this.dateForm.get('date')?.markAsTouched();
  }

  checkDateValue(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value.replace(/[^0-9\/]/g, '');
  }

  formatTime(time: any) {
    let formattedTime;
    if (this.timeFormat === '12') {
      formattedTime = moment(time, 'HH:mm').format('hh:mm A'); // Convert to 12-hour
    } else {
      formattedTime = moment(time, 'hh:mm A').format('HH:mm'); // Convert to 24-hour
    }
    // console.log(formattedTime, 'formattedTimejgbt');
    return formattedTime;
    // this.dateForm.get('time')?.setValue(formattedTime);
    // console.log(formattedTime, 'formattedTime');
    // console.log(this.dateForm.get('time')?.value)
  }
}
